import axios, { type AxiosInstance, type CreateAxiosDefaults } from 'axios';
import { attachCsrfInterceptor } from '@/js/lib/http/csrf';

const JSON_API_HEADERS = {
  'Accept': 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
} as const;

export function createJsonApiClient(
  config: CreateAxiosDefaults,
): AxiosInstance {
  const client = axios.create({
    withCredentials: true,
    ...config,
    headers: {
      ...JSON_API_HEADERS,
      ...config.headers,
    },
  });

  attachCsrfInterceptor(client);

  return client;
}
